import React from "react";
import MSelect, { MSelectOption } from "components/Shared/MSelect.tsx";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

interface CustomerSurveyTypeSelectionProps {
  onCustomerChange: (option: MSelectOption) => void;
  customerOptions: MSelectOption[];
  selectedCustomer: MSelectOption;
  onSurveyTypeChange: (option: MSelectOption) => void;
  surveyTypeOptions: MSelectOption[];
  selectedSurveyType: MSelectOption;
  confirmedSelection: boolean;
  onConfirmSelection: (value: boolean) => void;
  destinationCustomer: string;
}

const CustomerSurveyTypeSelection = (props: CustomerSurveyTypeSelectionProps) => {
  const getPortalTarget = () => document.body;

  return (
    <div>
      <div>
        <p>Select Customer Account:</p>
        <MSelect
          className="copy-survey-type-customer-dropdown"
          key="copy-survey-type-customer-dropdown"
          label="Select Customer Account"
          placeholder="Select Account..."
          isClearable={false}
          enableAllOption={false}
          onChange={props.onCustomerChange}
          options={props.customerOptions}
          value={props.selectedCustomer}
          getMenuPortalTarget={getPortalTarget}
        />
      </div>
      {props.selectedCustomer && (
        <div>
          <p>Select Survey Type to Copy:</p>
          <MSelect
            className="copy-survey-type-dropdown"
            key="copy-survey-type-dropdown"
            label="Select Survey Type"
            placeholder="Select Survey Type..."
            isClearable={false}
            enableAllOption={false}
            onChange={props.onSurveyTypeChange}
            options={props.surveyTypeOptions}
            value={props.selectedSurveyType}
            getMenuPortalTarget={getPortalTarget}
          />
        </div>
      )}
      {props.selectedSurveyType && (
        <FormControlLabel
          control={
            <Checkbox
              id="assign-appointment-dialog-send-confirmation"
              name="Confirm Selection"
              checked={props.confirmedSelection}
              onChange={(e) => props.onConfirmSelection(e.target.checked)}
            />
          }
          label={`Check to confirm you want to copy ${props.selectedSurveyType.label} from account ${props.selectedCustomer.label} to account ${props.destinationCustomer}`}
        />
      )}
    </div>
  );
};

export default CustomerSurveyTypeSelection;
